import { FooterWrapper } from "../index.styles";

export const B2bFooter = () => {
  return (
    <FooterWrapper>
      <div className="footer-left">© Orderlink Trade B2B portal for Bad Bottles</div>
      <div className="footer-right">
        <span>Email - sales@badbottles.nz</span>
        <span>Phone - +64 123 4567</span>
        <span>42 Commerce Street, Auckland</span>
      </div>
    </FooterWrapper>
  );
};
